export const TEMPLATES_STATE = 'templates'

export const TEMPLATES_EDIT_CATEGORY = 'templates/TEMPLATES_EDIT_CATEGORY'
export const BUY_SEAT = 'templates/BUY_SEAT'
export const REMOVE_BUY_SEAT = 'templates/REMOVE_BUY_SEAT'
